import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from '@/core/helpers/breadcrumb';
import { usePageToolbar, type PageToolbarOptions } from '@/core/hooks/usePageToolbar';
import type { IBreadcrumbLink } from '@/store/modules/BreadcrumbsModule';

export interface PageHeaderOptions extends PageToolbarOptions {
  /** Vuex page title (also used as header title when toolbar title omitted). */
  title: string;
  breadcrumbs?: IBreadcrumbLink[];
  withHomePage?: boolean;
}

/**
 * Sets page title/breadcrumbs and registers optional header actions
 * (Add, search, banner) for the shared PageToolbarHeader.
 */
export function usePageHeader(options: PageHeaderOptions): ReturnType<
  typeof usePageToolbar
> {
  const toolbar = usePageToolbar();

  setCurrentPageTitle(options.title);
  if (options.breadcrumbs) {
    setBreadcrumbLinks(options.breadcrumbs, options.withHomePage ?? true);
  }

  toolbar.usePageToolbarLifecycle({
    title: options.title,
    subtitle: options.subtitle,
    showBack: options.showBack,
    showSearch: options.showSearch,
    searchPlaceholder: options.searchPlaceholder,
    showFilter: options.showFilter,
    addLabel: options.addLabel,
    addPermissions: options.addPermissions,
    backgroundUrl: options.backgroundUrl,
    onAdd: options.onAdd,
    onFilter: options.onFilter,
    onBack: options.onBack,
  });

  return toolbar;
}
